import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { FilterMatchMode } from 'primereact/api';
import { useNavigate } from "react-router-dom";
import CommonConfig from "../../../utils/constant";
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import { useCatchResponse } from '../../../utils/useCatchResponse';


const UpdatePhotos = () => {
    const { catchResponse } = useCatchResponse();
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [managePhotosClassList, setManagePhotosClassList] = useState([]);
    const [selectedYear, setSelectedYear] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ClassName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };
    const filteredExams = managePhotosClassList?.filter(x =>
        x?.ClassName?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
        x?.TermName?.toLowerCase()?.includes(searchTerm?.toLowerCase())
    );

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        getFinancialYearData(loginData?._id);
    }, []);

    const getFinancialYearData = async (id) => {
        const years = await CommonConfig.getFinancialYears(id);
        const currentYear = CommonConfig.getCurrentFinancialYear(years);
        const selectedAcYear = CommonConfig.getCookie('selectedAcademicYear');
        setSelectedYear(selectedAcYear ?? currentYear?.value);
        await GetManagePhotosClassList(id, selectedAcYear ?? currentYear?.value);
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const GetManagePhotosClassList = async (id) => {
        try {
            let data = {
                UserId: id,
            }
            Loader.show();
            await api.post(APIConstant.path.GetManageStudentMasterDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    var onGoingList = res?.data;
                    setManagePhotosClassList(onGoingList);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    const actionTemplate = (rowData) => (
        <Button icon="pi pi-camera" tooltip="Update" tooltipOptions={{ position: 'top' }} className="e-sction-btn p-m-0" onClick={(e) => navigate('/update-photos-entry', { state: { className: rowData?.ClassName, classId: rowData?.ClassId, financialYearId: selectedYear } })} />
    );

    const srNoBodyTemplate = (data, props) => {
        return props?.rowIndex + 1;
    };

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-image"></i>
                    <h2>Update Photos</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                </div>
            </div>
            <DataTable value={filteredExams} paginator
                rows={rows}
                first={first}
                responsiveLayout="scroll"
                paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                rowsPerPageOptions={[5, 10, 20]}
                currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                onPage={onPageChange}
                className='custom-table'
                scrollHeight='calc(100vh - 120px)'
                size='small'
            >
                <Column header="Sr No" body={srNoBodyTemplate} style={{ maxWidth: "10%" }} />
                <Column field="ClassName" header="Class" style={{ maxWidth: "20%" }} />
                <Column field="StudentCount" header="Students" style={{ maxWidth: "17%" }} />
                <Column header="Action" headerClassName='e-template-action' bodyClassName='e-template-action' body={actionTemplate} style={{ maxWidth: "10%" }} />
            </DataTable>
        </div>
    );
};

export default UpdatePhotos;
